import { Input, Table, TableColumnsType } from "antd";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";
import { balanceBadge, sortIcon } from "components/Table";
import Action from "./components/Action";
import usePassengerWallet from "hooks/passengerWallets/usePassengerWallet";
import { IPassengerWallet } from "models/passengerWallet";
import { WalletAlertContextProvider } from "./components/AlertContext";
import { SearchOutlined } from "@ant-design/icons";

export default function PassengerWallet() {
  const {
    data: { data, loading, page, per_page, total, search },
    handlePageChange,
    handleSearch,
  } = usePassengerWallet();

  return (
    <WalletAlertContextProvider>
      <div className="w-full">
        <div className="w-full px-6 flex flex-wrap-reverse">
          <Input
            className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
            prefix={<SearchOutlined className="mr-2" />}
            placeholder="Search..."
            onChange={handleSearch}
            value={search}
          />
        </div>
        <div className="w-full mt-8 px-4">
          <Table
            loading={loading}
            columns={columns(page, per_page)}
            dataSource={data}
            onChange={handlePageChange}
            pagination={{
              total,
              pageSize: per_page,
              current: page,
              nextIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <NextIcon />
                </span>
              ),
              prevIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <PreviousIcon />
                </span>
              ),
            }}
          />
        </div>
      </div>
    </WalletAlertContextProvider>
  );
}

const columns = (
  page: number,
  perPage: number
): TableColumnsType<IPassengerWallet> => [
  {
    title: "No",
    render: (_, __, index) => {
      let number = index + 1 + (page - 1) * perPage;
      return <p className="text-base font-medium">{number}</p>;
    },
  },
  {
    title: "Passenger",
    dataIndex: "passenger",
    sorter: (a, b) =>
      `${a.passenger.first_name} ${a.passenger.last_name}`.localeCompare(
        `${b.passenger.first_name} ${b.passenger.last_name}`
      ),
    sortIcon,
    render: (value) => (
      <p>
        {value.first_name} {value.last_name}
      </p>
    ),
  },
  {
    title: "Phone",
    dataIndex: "passenger",
    sorter: (a, b) => a.passenger.phone.localeCompare(b.passenger.phone),
    sortIcon,
    render: (value) => <p>{value.phone}</p>,
  },
  {
    title: "Balance",
    dataIndex: "balance",
    sortIcon,
    render: balanceBadge,
    sorter: (a, b) => a.balance - b.balance,
  },
  {
    title: "Action",
    render: (value: IPassengerWallet) => <Action wallet={value} />,
  },
];
